import axios from 'axios';
import { ApiCommonParams, ResponseWithError } from '../models/app';
import { IProfileOrder } from '../models/profile';

export const requestGuestReturn = async ({
  lang,
  country,
  token,
  id_order,
  email,
  message
}: ApiCommonParams & {
  id_order: string;
  email: string;
  message: string;
}): Promise<ResponseWithError> => {
  const URL = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/user/guest/return`;

  return await axios.post(
    URL,
    { id_order, email, message },
    {
      headers: {
        ['UYN-BEARER']: token,
        ['UYN-LANGUAGE']: lang,
        ['UYN-COUNTRY']: country
      }
    }
  );
};

interface GuestOrderResponse {
  order: IProfileOrder | IProfileOrder[];
}

export const getGuestOrder = async ({
  lang,
  country,
  token,
  id_order,
  email
}: ApiCommonParams & {
  id_order: string;
  email: string;
}): Promise<IProfileOrder> => {
  const URL = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/guest/order`;

  const { data } = await axios.get<GuestOrderResponse>(URL, {
    headers: {
      ['UYN-BEARER']: token,
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country
    },
    params: {
      id_order,
      email: email.toLowerCase()
    }
  });

  const { order } = data || {};
  if (!order) {
    throw new Error('Not found');
  }
  if (Array.isArray(order) && order.length > 0) {
    return order[0];
  }
  return order as IProfileOrder;
};

export const getGuestOrderReturn = async ({
  lang,
  country,
  token,
  id_order,
  email
}: ApiCommonParams & {
  id_order: string;
  email: string;
}): Promise<IProfileOrder> => {
  const URL = `${process.env.NEXT_PUBLIC_WP_API_URL}/v1/guest/order-return`;

  const { data } = await axios.get<GuestOrderResponse>(URL, {
    headers: {
      ['UYN-BEARER']: token,
      ['UYN-LANGUAGE']: lang,
      ['UYN-COUNTRY']: country
    },
    params: {
      id_order,
      email: email.toLowerCase()
    }
  });

  const { order } = data || {};
  if (!order) {
    throw new Error('Not found');
  }
  if (Array.isArray(order) && order.length > 0) {
    return order[0];
  }
  return order as IProfileOrder;
};
